<template>
    <div>
        <div v-if="loaded" class="product-grid product-grid__wrapper">
            <div v-for="item in choices" :key="item" class="product-grid product-grid__product choice" @click="chooseItem(item, store)" :class="[(store.state.numberOfProductsFor2xGrid.includes(choices.length)) ? 'product-grid__product--two-grid-size' : 'product-grid__product--three-grid-size']">
                <div class="choice__content" :class="[(isActive(item) ) ? 'choice__content--active' : '']">
                    <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, false, false, false, true), store.methods.getImageClass('product-grid__image-box--', this) ]">
                        <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this)">
                            <p class="card-text choice__text" v-html="item" />
                        </div>
                    </div>                
                </div>
            </div>
        </div>
        <div v-if="!loaded" class="loading loading__wrapper">
        </div>
    </div>
</template>

<script>

import { inject } from 'vue';

export default {
    name: 'Choice',
    setup() {
        const store = inject('store');
        return {
            store
        }
    },
    data() {
        return {
            chosenSize: 0,
            chosenItem: null,
            linjer: [],
            images: new Map([]),
            loaded: true,
            choices:  ["Ja", "Nej", "Vet ej"]
        }
    },
    props: {
        order: String,
        title: String,
        endpoint: String,
        imageLayout: String,
        extraText: String
    },
    mounted() {
        const store = inject('store');
        let storageArray = JSON.parse(localStorage.selection);
        if (this.endpoint in storageArray && storageArray[this.endpoint] != null && Object.keys(storageArray[this.endpoint]).length ) {
            this.chosenItem = storageArray[this.endpoint].displayName;
            this.$emit('updateChosenProductCheckmark', "add")
        }
        store.methods.setStepAsLoaded(this);
        store.methods.updateLocalStorage(false, this, true)
    },
    methods: {
        chooseItem(item, store) {
            this.chosenItem = item;
            store.state.chosenItem = item;
            store.methods.updateLocalStorage(false, this, true);
            this.$emit('updateChosenProductCheckmark', "add")
        },
        isActive(item) {
            if (this.chosenItem == item ) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>
